import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import Score from './Score';
import CheckBox from './CheckBox';
import Radio from './Radio';
import Nps from './Nps';
import TextArea from './TextArea';
import MultiSelect from './MultiSelect';

function AdditionalQuestions({ index, questions, sourceId = 0, onChange }) {
  const { t } = useTranslation();

  const [answers, setAnswers] = useState([]);

  const orderedQuestions = (questions || []).map((item, index) => ({ ...item, order: index + 1 }));

  const handleChange = (question, answer) => {
    const i = answers.findIndex(obj => obj.questionId === question.id);
    if (i !== -1) {
      if (question.answer_type === "MULTISELECT" || question.answer_type === "RADIO") {
        answers[i].answer = answer;
      } else {
        answers[i].answer.value = answer;
        answers[i].answer.order = question.order;
        answers[i].answer.text = question.text
      }
    } else {

      var temp = {
        questionId: question.id,
        questionText: question.text,
        type: question.answer_type,
        answer: {}
      }
      if (question.answer_type === "MULTISELECT" || question.answer_type === "RADIO") {
        temp.answer = answer;
      } else {
        temp.answer.value = answer;
        temp.answer.order = question.order;
        temp.answer.text = question.text
      }
      answers.push(temp);
    }

    const sortedAnswers = answers.sort((a, b) => {
      const orderA = Array.isArray(a.answer) ? a.answer[0]?.order : a.answer.order;
      const orderB = Array.isArray(b.answer) ? b.answer[0]?.order : b.answer.order;
      return orderA - orderB;
    });

    onChange?.(index, sortedAnswers);
  }

  return (
    <div>
      {orderedQuestions && orderedQuestions.length > 0 &&
        <div className="row">
          <div className="col-sm-12">
            <h2>{t("review.tell")}</h2>
          </div>
        </div>
      }
      <div>

        {orderedQuestions && orderedQuestions.map((question, key) => {
          switch (question.answer_type) {
            case "SCORE": return (<Score key={key} value={-1} question={question} sourceId={sourceId} onChange={handleChange} />); // ok
            case "CHECKBOX": return (<CheckBox key={key} question={question} sourceId={sourceId} value={false} onChange={handleChange} />);
            case "RADIO": return (<Radio key={key} question={question} sourceId={sourceId} onChange={handleChange} />);
            case "NPS": return (<Nps key={key} question={question} sourceId={sourceId} onChange={handleChange} />); // ok
            case "TEXTAREA": return (<TextArea key={key} question={question} sourceId={sourceId} onChange={handleChange} />);
            case "MULTISELECT": return (<MultiSelect question={question} key={key} sourceId={sourceId} onChange={handleChange} />);
            default:
              return (<div></div>);
          }
        })}
      </div>
    </div>
  )
}
export default AdditionalQuestions
